import { formatCurrency, formatDate } from '@smarttransit/common'

const DEFAULT_FILTERS = {
  dateCategory: 'dateCreated',
  dateFrom: null,
  dateTo: null,
  balanceFilterOperator: '=',
  balanceFilterValue: '',
  ticketsFilterOperator: '=',
  ticketsFilterValue: '',
  daysOfNoTripsFilterValue: '',
  ticketFrequencyFilterEnabled: false,
  ticketFrequencyMinPurchasesPerWeek: 3,
  ticketFrequencyEvaluationWeeks: 2
}

function normalizeFilters (filters) {
  return Object.assign({}, DEFAULT_FILTERS, filters || {})
}

export default {
  name: 'passenger-extra-filters',
  props: {
    filters: Object,
    dateFieldPrefix: {
      type: String,
      default: 'passenger-extra-filters'
    },
    buttonBlock: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      modalOpen: false,
      localFilters: normalizeFilters(this.filters),
      ticketFrequencyMinPurchasesPerWeekItems: [1, 2, 3, 4, 5].map((n) => ({ text: String(n), value: n })),
      ticketFrequencyEvaluationWeeksItems: [1, 2, 3, 4, 6, 8, 12].map((n) => ({ text: String(n), value: n }))
    }
  },
  computed: {
    appliedFilters () {
      return normalizeFilters(this.filters)
    },
    extraFiltersTags () {
      const tags = []
      const filters = this.appliedFilters

      if (filters.balanceFilterValue) {
        const parsedBalanceFilterValue = Math.round(Number(filters.balanceFilterValue) * 100)
        tags.push(`Balance ${filters.balanceFilterOperator} ${formatCurrency(parsedBalanceFilterValue)}`)
      }

      if (filters.ticketsFilterValue) {
        tags.push(`Tickets ${filters.ticketsFilterOperator} ${filters.ticketsFilterValue}`)
      }

      if (filters.daysOfNoTripsFilterValue) {
        tags.push(`Days since last trip: ${filters.daysOfNoTripsFilterValue}`)
      }

      if (filters.ticketFrequencyFilterEnabled) {
        tags.push(`Ticket/top-up frequency: ${filters.ticketFrequencyMinPurchasesPerWeek}/week for ${filters.ticketFrequencyEvaluationWeeks} week${filters.ticketFrequencyEvaluationWeeks > 1 ? 's' : ''}`)
      }

      if (filters.dateCategory && (filters.dateFrom || filters.dateTo)) {
        tags.push(`${filters.dateCategory} ${[filters.dateFrom, filters.dateTo].filter(Boolean).map((o) => formatDate(o)).join(' - ')}`)
      }

      return tags
    },
    dateFromId () {
      return `${this.dateFieldPrefix}-date-from`
    },
    dateToId () {
      return `${this.dateFieldPrefix}-date-to`
    }
  },
  watch: {
    filters: {
      handler (value) {
        if (!this.modalOpen) {
          this.localFilters = normalizeFilters(value)
        }
      },
      deep: true
    }
  },
  methods: {
    openFilters () {
      this.localFilters = normalizeFilters(this.filters)
      this.modalOpen = true
    },
    applyFilters () {
      this.$emit('apply', normalizeFilters(this.localFilters))
      this.modalOpen = false
    }
  }
}

export {
  DEFAULT_FILTERS,
  normalizeFilters
}
